﻿package com.mgacreative.hotelru.feature.reports.di

import com.mgacreative.hotelru.feature.reports.ui.DashboardViewModel
import com.mgacreative.hotelru.feature.reports.ui.advanced.ReportsViewModel
import com.mgacreative.hotelru.feature.reports.ui.StatisticsViewModel
import org.koin.core.module.dsl.viewModel
import org.koin.dsl.module

fun getReportsFeatureModule() = module {
    viewModel { DashboardViewModel(get(), get()) }
    viewModel { ReportsViewModel(get(), get()) }
    viewModel { StatisticsViewModel(get(), get(), get()) }
}

